import './kwcafeterias/style';
import FormStructure from './kwcafeterias/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js